module.exports = function(data){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<div version="'+
((__t=(VERSION))==null?'':__t)+
'"\n  id="noticeModal"\n  class="modal md__modal__commons '+
((__t=(data.noticeClass))==null?'':__t)+
'"\n  role="dialog"\n  data-backdrop="static"\n  data-keyboard="false"\n>\n    <div class="modal-dialog">\n        <div class="modal-content noticeModal">\n            <div class="md__modal__header">\n                <div class="flex gap-12 align-center justify-space-between">\n                    <div class="flex align-center gap-20">\n                        <i id="alert-icon" class="'+
((__t=(data.icon))==null?'':__t)+
' h24 w32 f32"></i>\n                        <h4 class="md__modal__title">'+
((__t=(data.title))==null?'':__t)+
'</h4>\n                    </div>\n                    <button class="close" type="button"><i class="ri-close-line"></i></button>\n                </div>\n            </div>\n            <div class="md__modal__body" style="overflow: hidden">'+
((__t=(data.body))==null?'':__t)+
'</div>\n            <div class="md__modal__footer" style="display: block">\n                <div class="md__checkbox--wrapper">\n                    <input id="showNoticeAgain" type="checkbox" name="showNoticeAgain"\n                        class="md__checkbox--primary js-filter-hidden"><label for="showNoticeAgain">\n                        '+
((__t=(data.showItAgainLabel))==null?'':__t)+
'\n                    </label>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/modal.html
 ** module id = 9
 ** module chunks = 0
 **/